module.exports = __webpack_public_path__ + "static/img/t2.0e8e752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw/t2.png
// module id = WiAS
// module chunks = 1